<!-- 分成方管理列表 -->
<template>
  <scroll-layout>
    <template slot="header">
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @click="handleSearchConfirm"
        @clean="handleSearchClean"></ykc-search>
    </template>
    <div class="motorcade-main-account">
      <ykc-table
        ref="YkcTable"
        :data="tableData"
        :columns="tableColumns"
        :title="tableTitle"
        operateFixedType="right"
        :selectable="false"
        :selectOnIndeterminate="false"
        :operateButtons="tableOperateButtons">
        <template #headerButtons>
          <div class="table-header-button">
            <template v-for="(btn, i) in tableButtons">
              <ykc-button :type="btn.type" v-if="btn.enabled()" :key="i" @click="btn.handler">
                {{ btn.label }}
              </ykc-button>
            </template>
          </div>
        </template>
        <ykc-pagination
          slot="pagination"
          ref="YkcPagination"
          :total="pageInfo.total"
          :current-page.sync="pageInfo.current"
          @current-change="handlePaginationCurrentChange"
          :page-size.sync="pageInfo.size"
          @size-change="handlePaginationSizeChange"></ykc-pagination>
      </ykc-table>
    </div>
    <ykc-drawer
      :show.sync="showDrawer"
      :title="drawerTitle"
      :on-close="onAddDrawerClose"
      :before-cancel="onAddDrawerCancel"
      showDrawer
      ensure-txt="保存">
      <template #footer>
        <div class="drawer-button-wrap">
          <template v-for="(btn, i) in drawerButtons">
            <ykc-button :type="btn.type" v-if="btn.enabled()" :key="i" @click="btn.handler">
              {{ btn.label }}
            </ykc-button>
          </template>
        </div>
      </template>
      <div class="drawer-main-body" v-if="showDrawer">
        <AddOrEdit
          v-if="drawerType === 'edit' || drawerType === 'add'"
          ref="addOrEdit"
          :isEdit="isEdit"
          :id="id"></AddOrEdit>
      </div>
    </ykc-drawer>
  </scroll-layout>
</template>

<script>
  import YkcDialog from '@/components/ykc-ui/dialog/index';
  import AddOrEdit from './AddOrEdit.vue';
  import { partnerData } from '@/service/apis';
  import { code } from '@/utils';

  export default {
    name: 'PartnerList',
    components: {
      AddOrEdit,
    },
    data() {
      return {
        selectIds: [],
        id: '',
        drawerType: '',
        showDrawer: false,
        isEdit: false,
        isRequest: false,
        drawerButtons: [
          {
            label: '取消',
            type: 'plain',
            enabled: () => true,
            handler: () => {
              YkcDialog({
                dialogType: 'feedback',
                showTitle: false,
                showFooter: true,
                desc: '取消后操作将不被保存，确认是否取消？',
                onCancel: dialogDone => {
                  dialogDone();
                },
                onConfirm: dialogDone => {
                  dialogDone();
                  this.showDrawer = false;
                },
              });
            },
          },
          {
            label: '保存',
            enabled: () => {
              return true;
            },
            disabled: () => {
              return this.isRequest;
            },
            handler: () => {
              this.isRequest = true;
              this.$refs.addOrEdit
                .submitForm()
                .then(() => {
                  this.showDrawer = false;
                  this.isRequest = false;
                  this.searchTableList();
                })
                .finally(() => {
                  this.isRequest = false;
                });
            },
          },
        ],
        tableButtons: [
          {
            label: '新增',
            type: 'plain',
            enabled: () => code('operation:config:partner:add'),
            handler: () => {
              this.add();
            },
          },
        ],
        tableData: [],
        tableColumns: [
          { label: '分成方编号', prop: 'partnerNo', minWidth: '200px' },
          { label: '分成方名称', prop: 'partnerName', minWidth: '150px' },
          { label: '分成方类型', prop: 'partnerTypeName', minWidth: '120px' },
          { label: '结算周期', prop: 'settlementCycleName', minWidth: '100px' },
          { label: '分成方地址', prop: 'partnerAddress', minWidth: '150px' },
          { label: '资质名称', prop: 'aptitudeName', minWidth: '150px' },
          { label: '联系人姓名', prop: 'contacts', minWidth: '120px' },
          { label: '联系人性别', prop: 'contactsSexName', minWidth: '100px' },
          { label: '联系人手机号', prop: 'contactsPhone', minWidth: '130px' },
          { label: '联系人职务', prop: 'contactsJob', minWidth: '120px' },
          { label: '联系人邮箱', prop: 'contactsEmail', minWidth: '150px' },
          { label: '联系人电话', prop: 'contactsTelephone', minWidth: '130px' },
          { label: '收款单位名称', prop: 'company', minWidth: '160px' },
          { label: '收款银行', prop: 'bank', minWidth: '160px' },
          { label: '收款账号', prop: 'bankNo', minWidth: '160px' },
          { label: '创建人', prop: 'createdByName', minWidth: '120px' },
          { label: '创建时间', prop: 'createdTime', minWidth: '160px' },
          { label: '最后编辑人', prop: 'modifiedByName', minWidth: '120px' },
          { label: '最后编辑时间', prop: 'modifiedTime', minWidth: '160px' },
        ],
        tableTitle: '分成方列表',
        tableOperateButtons: [
          {
            render: (h, data, { row }) =>
              code('operation:config:partner:detail') ? (
                <ykc-button
                  type="text"
                  onClick={() => {
                    this.detailLink(row);
                  }}>
                  详情
                </ykc-button>
              ) : null,
          },
          {
            render: (h, data, { row }) =>
              code('operation:config:partner:edit') ? (
                <ykc-button
                  type="text"
                  onClick={() => {
                    this.isEdit = true;
                    this.id = row.id;
                    this.drawerType = 'edit';
                    this.showDrawer = true;
                  }}>
                  编辑
                </ykc-button>
              ) : null,
          },
        ],
        pageInfo: {
          total: 0,
          current: 1,
          size: 10,
        },
        searchParams: {
          partnerNo: '',
          partnerName: '',
          partnerType: '',
        },
      };
    },
    created() {
      this.searchTableList();
    },
    computed: {
      drawerTitle() {
        return `分成方${this.isEdit ? '编辑' : '新增'}`;
      },
      searchData() {
        return [
          {
            comName: 'YkcInput',
            key: 'partnerNo',
            label: '分成方编号',
            placeholder: '请输入分成方编号',
          },
          {
            comName: 'YkcInput',
            key: 'partnerName',
            label: '分成方名称',
            placeholder: '请输入分成方名称',
          },
          {
            comName: 'YkcDropdown',
            key: 'partnerType',
            label: '分成方类型',
            placeholder: '请选择分成方类型',
            data: [
              { id: '', name: '全部' },
              { id: 1, name: '物业集团' },
              { id: 2, name: '外部居间方' },
              { id: 3, name: '代建方' },
              { id: 4, name: '其他' },
            ],
          },
        ];
      },
    },
    methods: {
      detailLink(row) {
        this.$router.push({
          path: '/operationCenter/propertymentConfig/partnerManage/detail',
          query: {
            id: row.id,
          },
        });
      },
      add() {
        this.isEdit = false;
        this.id = '';
        this.drawerType = 'add';
        this.showDrawer = true;
      },
      searchTableList() {
        partnerData
          .partnerList({
            ...this.pageInfo,
            ...this.searchParams,
          })
          .then(res => {
            this.tableData = res?.records;
            this.pageInfo.total = res?.total || 0;
          });
      },
      onAddDrawerClose(done) {
        done();
      },
      onAddDrawerCancel(drawerDone) {
        YkcDialog({
          dialogType: 'feedback',
          showTitle: false,
          showFooter: true,
          desc: '取消后操作将不被保存，确认是否取消？',
          onCancel: done => {
            done();
          },
          onConfirm: done => {
            done();
            drawerDone();
            if (this.isEdit) {
              this.isEdit = false;
            }
          },
        });
      },
      handleSearchConfirm(form) {
        this.pageInfo.current = 1;
        Object.assign(this.searchParams, form);
        this.searchTableList();
      },
      handleSearchClean(form) {
        Object.assign(this.searchParams, form);
      },
      handlePaginationCurrentChange(current) {
        this.pageInfo.current = current;
        this.searchTableList();
      },
      handlePaginationSizeChange(size) {
        this.pageInfo.current = 1;
        this.pageInfo.size = size;
        this.searchTableList();
      },
    },
  };
</script>
<style lang="scss" scoped>
  .link {
    color: blue;
    cursor: pointer;
  }
  .el-radio-group .item {
    border: 0;
  }
</style>
